import React from "react";
import PropTypes from "prop-types";

const LogCard = ({
  type,
  count,
  percentage,
  darkMode,
  description,
  onClick,
}) => {
  const containerStyle = {
    flex: "1 0 calc(25% - 15px)",
    maxWidth: "300px",
    backgroundColor: darkMode ? "#333333" : "#f8f9fa",
    color: darkMode ? "#e9ecef" : "#333333",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.15)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    textAlign: "center",
    transition: "transform 0.2s ease",
    cursor: "pointer", // Adiciona um cursor de ponteiro para indicar que é clicável
  };

  const titleStyle = {
    color: "#1d8cf8",
    fontSize: "1.2rem",
    fontWeight: "bold",
    marginBottom: "10px",
  };

  const countStyle = {
    fontSize: "2.5rem",
    fontWeight: "bold",
    margin: "10px 0",
  };

  const progressBarContainerStyle = {
    width: "100%",
    height: "10px",
    background: "#e0e0e0",
    borderRadius: "5px",
    overflow: "hidden",
    marginTop: "15px",
  };

  const progressBarStyle = {
    width: `${percentage}%`,
    height: "100%",
    background: `linear-gradient(90deg, #1d8cf8, #f96332)`,
    transition: "width 0.5s ease",
  };

  return (
    <div
      style={containerStyle}
      onClick={onClick} // Torna o card clicável
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <h5 style={titleStyle} title={description}>
        {type}
      </h5>
      <h3 style={countStyle}>{count}</h3>
      <div style={progressBarContainerStyle}>
        <div style={progressBarStyle}></div>
      </div>
    </div>
  );
};

LogCard.propTypes = {
  type: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  percentage: PropTypes.number.isRequired,
  darkMode: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired, // Propriedade para a ação de clique
};

export default LogCard;
